export default __webpack_public_path__ + "static/media/13-bottom.463954a8.png";